<div class="containerMarginX text-center">
  <div
    *ngIf="!updateData; then thenBlockGeneral; else elseBlockGeneral"
    class="container firstRegister mt-5"
  ></div>
  <ng-template #thenBlockGeneral>
    <h2 class="blue mt-4">{{ 'k002658' | translate }}</h2>
    <!-- Token: Continuemos donde nos hemos quedado -->
    <p class="mb-50" [innerHTML]="'k002659' | translate">
      <!-- Token: Puedes ver el paso en el que te encuentras. Haz clic en el botón <i>Continuar</i> para seguir el proceso donde lo dejaste. -->
    </p>
  </ng-template>
  <ng-template #elseBlockGeneral>
    <h2 class="blue mt-4">{{ 'k002668' | translate }}</h2>
    <!-- Token: Ya casi hemos finalizado el registro, pero... -->
    <p class="mb-50" [innerHTML]="'k002669' | translate">
      <!-- Token: Se ha detectado alguna incidencia en el proceso de registro. Nuestro
      equipo te ha enviado un email con las causas. Haz clic en
      <i>continuar</i> para corregir la información requerida. -->
    </p>
  </ng-template>
  <tech-roadmap [step]="step"></tech-roadmap>
</div>
